import React from "react";
import { useMediaQuery } from "usehooks-ts";
import { railContainer, railStickyContainer } from "./GoogleRailAdUnit.css";
import GoogleAdUnit from "./GoogleAdUnit";

interface Props {
    position: "left" | "right";
}

const GoogleRailAdunit: React.FC<Props> = ({ position }) => {
    const match = useMediaQuery("(min-width: 1384px)", {
        initializeWithValue: false,
        defaultValue: false,
    });

    // console.log("GoogleRailAdunit", position, match);

    if (!match) return null;

    return (
        <div className={railContainer[position]}>
            <div className={railStickyContainer}>
                <GoogleAdUnit id={`news-page-${position}-rail`} />
            </div>
        </div>
    );
};

export default GoogleRailAdunit;
